import { useNotifications } from '../../contexts/NotificationContext.jsx';
import './Toast.css';

function Toast() {
  const { toasts, removeToast } = useNotifications();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" aria-live="polite" role="status">
      {toasts.map((toast) => (
        <div
          key={toast.toastId}
          className={`toast-item${toast.leaving ? ' toast-leaving' : ''}`}
        >
          <div className="toast-content">
            <strong className="toast-title">{toast.title}</strong>
            {toast.body && <p className="toast-body">{toast.body}</p>}
          </div>
          <button
            className="toast-close"
            onClick={() => removeToast(toast.toastId)}
            aria-label="Fermer"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}

export default Toast;
